<template>
  <Alert v-if="showAlert && hasOldUploads && !hasAlert && !isInMobileApp" tone="neutral" :dismissable="true" class="alert-neutral">
    <span v-html="msg"></span>
  </Alert>
</template>

<script setup lang="ts">
import "@/src/i18n";
import { inject, ref } from "vue";
import emitter from "@/modules/event_bus";
import User from "@/modules/user";
import { Alert } from "prism";

const hasOldUploads = ref<boolean>(false);
const hasAlert = ref<boolean>(false);
const showAlert = ref<boolean>(false);
const isInMobileApp = ref<boolean>(false);

const I18n = inject("I18n");
const path = User.newEditorUrl();
const msg = I18n.t("inline_editor.old_images_present_html", { link: path + "?showOldUploads=true" });

const checkAlerts = () => {
  hasAlert.value = document.querySelector("#flashes .alert-neutral") !== null;
};

const checkOldUploads = () => {
  hasOldUploads.value = User.hasOldUploads();
};

emitter.on("newEditorPageMounted", () => {
  showAlert.value = true;
  isInMobileApp.value = User.mobileApp();
  checkAlerts();
  checkOldUploads();
});
</script>
